import React from 'react';
import { BookOpenIcon, CheckIcon, ScrollTextIcon } from 'lucide-react';
import { MapCarousel } from './MapCarousel';
import { blockChips, mainProduct, mapBlocks, mapFeatures } from '../data/content';
const icons = {
  book: BookOpenIcon,
  scroll: ScrollTextIcon
};
export function MainProduct() {
  return <section id="incluye" className="bg-night" data-id="element-143" data-mp="33kh52wvplmnf">
      <div className="mx-auto max-w-content px-6 py-16 lg:py-24" data-id="element-144" data-mp="33hl6r7fy8vyg">
        <div className="mx-auto max-w-3xl text-center" data-id="element-145" data-mp="439eiy96ish6">
          <span className="inline-flex items-center gap-2 rounded-full border border-gold-soft/40 px-4 py-1.5 font-sans text-xs font-semibold uppercase tracking-[0.14em] text-gold-soft" data-id="element-146" data-mp="38o0f8t2qtr">
            🧭 GPS Bíblico™ · Sistema completo
          </span>
          <h2 className="mt-6 font-display text-3xl font-semibold leading-tight tracking-tight text-parchment sm:text-5xl" data-id="element-147" data-mp="3m9nm8fguu674">
            {mainProduct.title}
          </h2>
          <p className="mt-4 font-display text-2xl font-semibold text-gold-soft" data-id="element-148" data-mp="2auquuyx774wl">
            73 mapas mentales — Antiguo y Nuevo Testamento
          </p>
          <p className="mt-5 font-sans text-base leading-relaxed text-parchment/70" data-id="element-149" data-mp="39z9i6jzwvjlz">
            {mainProduct.description}
          </p>
        </div>

        <ul className="mt-10 flex flex-wrap justify-center gap-3" data-id="element-150" data-mp="301v2imltayuq">
          {blockChips.map(chip => <li key={chip.label} className="flex min-w-[7.5rem] flex-col items-center rounded-xl border border-night-line bg-night-panel px-4 py-3" data-id="element-151" data-mp="350pry7eablnt">
              <span aria-hidden="true" className="h-1.5 w-10 rounded-full" style={{
            backgroundColor: chip.color
          }} data-id="element-152" data-mp="2v4v3gvndqwd4" />
              <span className="mt-2 font-sans text-sm font-semibold text-parchment" data-id="element-153" data-mp="2mb009t5tjg04">
                {chip.label}
              </span>
              <span className="font-sans text-xs text-parchment/55" data-id="element-154" data-mp="27esi0ydz0onh">{chip.books}</span>
            </li>)}
        </ul>

        <div className="mt-14 grid items-start gap-10 lg:grid-cols-[1.05fr_0.95fr] lg:gap-14" data-id="element-155" data-mp="2cf6f5le1ae6q">
          <MapCarousel data-id="element-156" data-mp="1tate50ddigcm" />

          <div data-id="element-157" data-mp="1oia3oc9zg1c1">
            <div className="space-y-6" data-id="element-158" data-mp="1ohqjsq0rv2vd">
              {mapBlocks.map(block => {
              const Icon = icons[block.icon];
              return <article key={block.title} className="flex gap-4 rounded-2xl border border-night-line bg-night-panel p-6" data-id="element-159" data-mp="1jgkpinrgr7jq">
                    <Icon className="mt-1 h-6 w-6 flex-none text-gold-soft" aria-hidden="true" data-id="element-160" data-mp="2c5i9cvbbpcel" />
                    <div data-id="element-161" data-mp="228dl8pxx36v5">
                      <h3 className="font-display text-xl font-semibold leading-snug text-parchment" data-id="element-162" data-mp="227k9tbo0jt6o">
                        {block.title}
                      </h3>
                      <p className="mt-2 font-sans text-sm leading-relaxed text-parchment/70" data-id="element-163" data-mp="qui2l77t0fz6">
                        {block.description}
                      </p>
                    </div>
                  </article>;
            })}
            </div>

            <div className="mt-6 rounded-2xl border border-gold-soft/30 bg-gold/5 p-6 lg:p-8" data-id="element-164" data-mp="32hle7z1umahh">
              <h3 className="text-center font-display text-xl font-semibold text-gold-soft" data-id="element-165" data-mp="37goi3g63eanv">
                Qué vas a encontrar en cada mapa
              </h3>
              <ul className="mt-5 space-y-3" data-id="element-166" data-mp="3c8zg2dh9vmds">
                {mapFeatures.map(feature => <li key={feature} className="flex gap-3" data-id="element-167" data-mp="3h5ya6w0xrtbz">
                    <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold-soft" aria-hidden="true" data-id="element-168" data-mp="3l7jtaz42d3um" />
                    <span className="font-sans text-base text-parchment/85" data-id="element-169" data-mp="3q5d1fxoxg7xj">
                      {feature}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}